import React, { memo } from 'react';
import { Alert, type SxProps, type Theme } from '@mui/material';

export interface InlineAlertProps {
  severity: 'success' | 'error' | 'warning' | 'info';
  children: React.ReactNode;
  onClose?: () => void;
  variant?: 'standard' | 'outlined';
  icon?: React.ReactNode;
  action?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const InlineAlert: React.FC<InlineAlertProps> = memo(({
  severity,
  children,
  onClose,
  variant = 'standard',
  icon,
  action,
  sx,
}) => (
  <Alert
    severity={severity}
    onClose={onClose}
    variant={variant}
    icon={icon === undefined ? undefined : icon}
    action={action}
    sx={sx}
  >
    {children}
  </Alert>
));

InlineAlert.displayName = 'InlineAlert';

export default InlineAlert;
